import React from 'react';

export default function Loading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-200">
      <div className="animate-bounce mb-4">
        <img
          src={'/mmd/mmd.png'}
          alt={'asia-ceramic.png'}
          height={50}
          width={50}
        />
      </div>
      <p className="text-gray-600">Please wait..</p>
    </div>
  );
}
